import { isServer } from "@/lib/env-utils/env-utils"

type CustomScrollEventDetails = any
export interface ScrollToElementOptions {
    smooth?: boolean
    xOffset?: number
    yOffset?: number
    eventDetails?: CustomScrollEventDetails
}
export interface ScrollToOptions {
    smooth?: boolean
    left?: number
    top?: number
    eventDetails?: CustomScrollEventDetails
}
const customScrollEvent = (details: CustomScrollEventDetails) => {
    if (!isServer) {
        window.dispatchEvent(new CustomEvent("scrollTo", { detail: details }))
    }
}

export const scrollTo = ({
    smooth = true,
    left = 0,
    top = 0,
    eventDetails
}: ScrollToOptions) => {
    if (!isServer) {
        if (
            document.documentElement &&
            "scrollBehavior" in document.documentElement.style
        ) {
            window.scrollTo({
                behavior: smooth !== false ? "smooth" : "auto",
                left,
                top
            })
        } else {
            window.scrollTo(left, top)
        }
        // Trigger a custom scroll event that can be used to trigger other actions on the site
        if (eventDetails) {
            customScrollEvent(eventDetails)
        }
    }
}
export const scrollToElement = (
    element: Element | null,
    { smooth = true, xOffset = 0, yOffset = 0, eventDetails }: ScrollToElementOptions
) => {
    // @todo: check if this works
    if (element && !isServer) {
        const top = (element.getBoundingClientRect()?.top || 0) + window.scrollY + yOffset
        const left =
            (element.getBoundingClientRect()?.left || 0) + window.scrollX + xOffset
        scrollTo({
            smooth,
            top,
            left,
            eventDetails
        })
        customScrollEvent(eventDetails)
    }
}
